import type {
  PresenceViewerDto,
  QuestionSseEvent,
  QuestionThreadDto,
} from '@lib/dto/question.dto'

export function hasUnansweredThreads(
  threads: readonly QuestionThreadDto[],
): boolean {
  return threads.some((thread) => {
    const last = thread.messages[thread.messages.length - 1]
    return last?.authorType === 'asker'
  })
}

export function upsertThread<T extends { threads: QuestionThreadDto[] }>(
  current: T,
  thread: QuestionThreadDto,
): T {
  const exists = current.threads.some((item) => item.id === thread.id)
  return {
    ...current,
    threads: exists
      ? current.threads.map((item) => (item.id === thread.id ? thread : item))
      : [...current.threads, thread],
  }
}

export function mergeQuestionEvent<
  T extends { threads: QuestionThreadDto[]; viewers: PresenceViewerDto[] },
>(current: T, event: QuestionSseEvent): T {
  if (event.type === 'presence') {
    return { ...current, viewers: event.viewers }
  }
  if (event.type === 'question.created') {
    return upsertThread(current, event.thread)
  }
  return {
    ...current,
    threads: current.threads.map((thread) => {
      if (thread.id !== event.threadId) {
        return thread
      }
      if (thread.messages.some((message) => message.id === event.message.id)) {
        return thread
      }
      return { ...thread, messages: [...thread.messages, event.message] }
    }),
  }
}
